import { render } from "./CopyButton.vue?vue&type=template&id=2b16e8c6&scoped=true"
import script from "./CopyButton.vue?vue&type=script&lang=js"
export * from "./CopyButton.vue?vue&type=script&lang=js"

import "./CopyButton.vue?vue&type=style&index=0&id=2b16e8c6&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b16e8c6"]])

export default __exports__